const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']

const formatDate = (input) => {
    var datePart = input.match(/\d+/g),
    year = datePart[0],//.substring(2), // get only two digits
    month = datePart[1], day = datePart[2];

    // console.log("datePart", datePart);

    return day+'/'+month+'/'+year;
};



const dateToString = (date, charSeparador = "/", lang = "es") => {
    if (!date) return "";

    const fecha = new Date(date);
    if (lang === "es"){
        var mm = fecha.getMonth() + 1; // getMonth() is zero-based
        var dd = fecha.getDate();
      
        return [(dd>9 ? '' : '0') + dd,
                (mm>9 ? '' : '0') + mm,
                fecha.getFullYear()
               ].join('/');
        // return (fecha.getDate() + 1).toString().padStart(2, "0") + charSeparador + (fecha.getMonth() + 1).toString().padStart(2, "0") + charSeparador + fecha.getFullYear().toString();
    }
    else if (lang === "en")
        return fecha.getFullYear().toString() + charSeparador + (fecha.getMonth() + 1).toString().padStart(2, "0") + charSeparador + fecha.getDate().toString().padStart(2, "0") ;
    return ""
}

const dateToLongString = date => {
    if (!date) return "";
    return date.getDate() + ' de ' + meses[date.getMonth()] + ' del ' + date.getFullYear()
}

const datetimeToString = (date, charSeparador = "/", lang = "es") => {
    if (!date) return "";

    if (lang === "es")
        return date.getDate().toString().padStart(2, "0") + charSeparador + (date.getMonth() + 1).toString().padStart(2, "0") + charSeparador + date.getFullYear().toString() + ' ' + date.getHours().toString().padStart(2, "0") + ':' + date.getMinutes().toString().padStart(2, "0");
    else if (lang === "en")
        return date.getFullYear().toString() + charSeparador + (date.getMonth() + 1).toString().padStart(2, "0") + charSeparador + date.getDate().toString().padStart(2, "0");
}

const dateToMesAnio = (date) => {
    return meses[date.getMonth()] + ' ' + date.getFullYear()
}

export {
    dateToString,
    dateToLongString,
    datetimeToString,
    dateToMesAnio,
    formatDate
};